<!-- vertical layout -->
<app-vertical *ngIf="!layoutChange"></app-vertical>

<!-- horizontal layout -->
<app-horizontal *ngIf="layoutChange"></app-horizontal>

